import React from 'react';

const PetIcon = ({ species, size = 20 }) => {
  const s = (species || '').toLowerCase();
  const emoji = (s === 'dog' || s === 'köpek') ? '\uD83D\uDC36' : (s === 'cat' || s === 'kedi') ? '\uD83D\uDC31' : (s === 'bird' || s === 'kuş') ? '\uD83D\uDC26' : '\uD83D\uDC3E';
  return <span style={{ fontSize: `${size}px`, lineHeight: 1 }}>{emoji}</span>;
};

export default PetIcon;
